/*!
 * Pika Infinite Loop for Impact media-carousel (mobile only) — v1.2
 * - správná synchronizace page-dots
 * - klik na dot přeskakuje na správný snímek
 * - garantujeme počet teček == počet reálných snímků (odmaskujeme "hidden" doty)
 */
(function () {
  const MOBILE_MAX = 999; // px
  const isMobile = () => window.matchMedia(`(max-width: ${MOBILE_MAX}px)`).matches;
  const raf = (fn) => requestAnimationFrame(fn);

  function widthWithMargin(el) {
    const r = el.getBoundingClientRect();
    const cs = getComputedStyle(el);
    return r.width + parseFloat(cs.marginLeft) + parseFloat(cs.marginRight);
  }
  function jump(el, left) {
    el.style.scrollBehavior = 'auto';
    el.scrollLeft = left;
    el.style.scrollBehavior = '';
  }
  function getRealSlides(carousel) {
    // reálné (ne-klony, ne-hidden wrappery od tématu)
    return Array.from(carousel.children).filter(
      (n) => !n.hasAttribute('hidden') && !n.hasAttribute('data-clone')
    );
  }
  function dotsGroups(carousel) {
    const id = carousel.id;
    if (!id) return [];
    return Array.from(document.querySelectorAll(`page-dots[aria-controls="${CSS.escape(id)}"]`));
  }
  function setDot(groups, realIndex) {
    groups.forEach((g) => {
      const dots = Array.from(g.children).filter((b) => !b.hidden);
      dots.forEach((b, i) => b.setAttribute('aria-current', i === realIndex ? 'true' : 'false'));
    });
  }
  // === NEW: zajistíme, že je vidět tolik teček, kolik je reálných snímků ===
  function ensureDotsCount(carousel, groups) {
    const len = getRealSlides(carousel).length;
    groups.forEach((g) => {
      const btns = Array.from(g.children);
      // nejdřív všechny schovej, pak první "len" odmaskuj
      btns.forEach((b) => (b.hidden = true));
      let shown = 0;
      for (const b of btns) {
        if (shown >= len) break;
        b.hidden = false;
        shown++;
      }
    });
  }

  function initOne(carousel) {
    if (carousel.__pikaLoopInit || !isMobile()) return;
    if (!carousel.matches('[data-loop], [data-loop="true"]')) return;

    carousel.setAttribute('selector', ':scope > :not([data-clone])');
    let realSlides = getRealSlides(carousel);
    if (realSlides.length < 2) return;

    // klony
    const first = realSlides[0];
    const last = realSlides[realSlides.length - 1];
    const firstClone = first.cloneNode(true);
    const lastClone = last.cloneNode(true);
    firstClone.setAttribute('data-clone', 'head');
    lastClone.setAttribute('data-clone', 'tail');
    firstClone.setAttribute('aria-hidden', 'true');
    lastClone.setAttribute('aria-hidden', 'true');
    firstClone.inert = true;
    lastClone.inert = true;

    carousel.insertBefore(lastClone, carousel.firstElementChild);
    carousel.appendChild(firstClone);

    const step = () => widthWithMargin(first);
    const groups = dotsGroups(carousel);

    // Zaruč správný počet teček hned na startu
    ensureDotsCount(carousel, groups);

    // start: za "tail" klon
    raf(() => jump(carousel, step()));

    const getVirtualIndex = () => {
      const s = step();
      return Math.round(carousel.scrollLeft / (s || 1)); // 0 .. real+1
    };
    const getRealIndex = () => {
      realSlides = getRealSlides(carousel);
      const v = getVirtualIndex();
      const len = realSlides.length;
      let i = v - 1;
      if (i < 0) i = len - 1;
      if (i >= len) i = 0;
      return i;
    };

    let ticking = false;
    const onScroll = () => {
      if (ticking) return;
      ticking = true;
      raf(() => {
        ensureDotsCount(carousel, groups);
        setDot(groups, getRealIndex());
        ticking = false;
      });
      clearTimeout(onScroll._t);
      onScroll._t = setTimeout(handleScrollEnd, 140);
    };

    function handleScrollEnd() {
      const s = step();
      if (!s) return;
      const len = getRealSlides(carousel).length;
      const v = getVirtualIndex();
      if (v === 0) {
        jump(carousel, s * len);
        setDot(groups, len - 1);
      } else if (v === len + 1) {
        jump(carousel, s);
        setDot(groups, 0);
      }
    }

    // klik na dot
    groups.forEach((g) => {
      g.addEventListener(
        'click',
        (ev) => {
          const btn = ev.target.closest('button');
          if (!btn) return;
          const dots = Array.from(g.children).filter((b) => !b.hidden);
          const target = dots.indexOf(btn);
          if (target === -1) return;
          ev.preventDefault();
          ev.stopPropagation();
          const s = step();
          carousel.scrollTo({ left: s * (target + 1), behavior: 'smooth' });
          setDot(groups, target);
        },
        true
      );
    });

    const root = carousel.closest('.product-gallery__media-list-wrapper') || carousel.parentElement;
    const nextBtn = root?.querySelector('next-button');
    const prevBtn = root?.querySelector('prev-button');
    const go = (d) => {
      const s = step();
      carousel.scrollTo({ left: carousel.scrollLeft + d * s, behavior: 'smooth' });
    };
    nextBtn?.addEventListener('click', () => go(+1));
    prevBtn?.addEventListener('click', () => go(-1));

    carousel.addEventListener('scroll', onScroll, { passive: true });

    // init
    ensureDotsCount(carousel, groups);
    setDot(groups, getRealIndex());

    if ('ResizeObserver' in window) {
      const ro = new ResizeObserver(() => {
        const i = getRealIndex();
        ensureDotsCount(carousel, groups);
        jump(carousel, step() * (i + 1));
        setDot(groups, i);
      });
      ro.observe(carousel);
    }

    carousel.__pikaLoopInit = true;
  }

  function boot() {
    if (!isMobile()) return;
    document.querySelectorAll('media-carousel.product-gallery__media-list').forEach(initOne);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot, { once: true });
  } else {
    boot();
  }
  window.addEventListener('shopify:section:load', boot);
  window.addEventListener('resize', () => {
    if (isMobile()) boot();
  });
})();
